import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const WarningTriangleFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 21L23 21L12 2L1 21ZM13 18L11 18L11 16L13 16L13 18ZM13 14L11 14L11 10L13 10L13 14Z"
      fill="currentColor"
    />
  </svg>
);

WarningTriangleFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(WarningTriangleFilledIcon);
